import React from 'react';

/**
 * A reusable Checkbox component.
 *
 * @param {object} props - Component props.
 * @param {string} [props.id] - ID for the checkbox, also used for label's htmlFor.
 * @param {string} [props.name] - Name attribute for the checkbox.
 * @param {string} [props.label] - Label text displayed next to the checkbox.
 * @param {boolean} [props.checked] - Controlled component value (true/false).
 * @param {function} [props.onChange] - Change event handler.
 * @param {boolean} [props.disabled=false] - If true, checkbox is disabled.
 * @param {string} [props.className=''] - Additional custom Tailwind classes for the input element.
 * @param {string} [props.labelClassName=''] - Additional custom Tailwind classes for the label text.
 * @param {string} [props.containerClassName=''] - Additional custom Tailwind classes for the wrapper div.
 */
const Checkbox = ({
    id,
    name,
    label,
    checked,
    onChange,
    disabled = false,
    className = '',
    labelClassName = '',
    containerClassName = '',
    ...props
}) => {
    return (
        <div className={`flex items-center mb-4 ${containerClassName}`}>
            <input
                type="checkbox"
                id={id || name}
                name={name}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                className={`form-checkbox h-4 w-4 text-gmail-blue border-gray-300 rounded focus:ring-gmail-blue focus:ring-offset-0 transition-colors duration-200 ease-in-out ${className}`}
                {...props}
            />
            {label && (
                <label htmlFor={id || name} className={`ml-2 text-sm text-text-secondary cursor-pointer ${labelClassName}`}>
                    {label}
                </label>
            )}
        </div>
    );
};

export default Checkbox;
